<template>
	<div class="wrapper" :style="position">
		<div class="card" :style="groupSize">
			<!-- <div class="card-body"> -->
				<p v-if="label" class="card-text">{{ $t(label) }}</p>
			<!-- </div> -->

			<m3t3d1Graph v-if="graph == 'm3_t3_d1'" :selectedIndex="selectedIndex" :selectedValue="selectedValue" />
			<m3t3d2Graph v-if="graph == 'm3_t3_d2'" :selectedIndex="selectedIndex" :selectedValue="selectedValue" />
			<m3t3d3Graph v-if="graph == 'm3_t3_d3'" :selectedIndex="selectedIndex" :selectedValue="selectedValue" />

			<!-- Image preloader -->
			<div v-for="(image,index) in sliderImages" :key="index" style="position: absolute; left: -10000px;">
				<img :src='"@/assets/" + image + ""' style="width: 0px; height: 0px;" />
			</div>
		</div>
	</div>
</template>



<script>
import m3t3d1Graph from '@/components/graphs/m3t3d1Graph.vue';
import m3t3d2Graph from '@/components/graphs/m3t3d2Graph.vue';
import m3t3d3Graph from '@/components/graphs/m3t3d3Graph.vue';

export default {
	props: [ "groupId", "label", "slots", "pos", "anchor", "boxWidth", "boxHeight", "image", "sliderImages", "color", "border", "graph" ],
	components: { m3t3d1Graph, m3t3d2Graph, m3t3d3Graph },
	data() {
		return {
			selectedIndex: 0,
			selectedValue: 0,
		};
	},
	computed: {
		position() {
			const ax = this.anchor.x;
			const ay = this.anchor.y;
			return {
				left: `${this.x}%`,
				top: `${this.y}%`,
				transform: `translate(${-ax*100}%, ${-ay*100}%)`,
				width: `${this.boxWidth}%`,
				height: `${this.boxHeight}%`,
			};
		},
		groupSize() {
			let style = {
				// width: `${this.boxWidth}vh`,
				// height: `${this.boxHeight}vh`,
				width: "100%",
				height: "100%",
				backgroundColor: `${this.color}`
			};

			if (this.image) {
				style.backgroundImage = `url(${require(`@/assets/${this.image}`)})`;
			}

			if (this.sliderImages) {
				style.backgroundImage = `url(${require(`@/assets/${this.sliderImages[this.selectedIndex]}`)})`;
			}

			if (this.color != "transparent") {
				style.border = `2px solid ${this.border}`;
			}

			return style;
		},

		rect() {
			return this.$refs.card.getBoundingClientRect();
		},
		x() {
			return this.pos.x;
		},
		y() {
			return this.pos.y;
		},
		width() {
			return this.rect.width * this.widthRatio;
			// return this.$refs.card.offsetWidth;
		},
		height() {
			return this.rect.height * this.heightRatio;
			// return this.$refs.card.offsetHeight;
		},
	}
};
</script>



<style scoped>
	.wrapper {
		position: absolute;
	}


	.card {
		border: none;
		border-radius: 0.4em;
		/*color: white;*/
		padding: 0.2em;
		user-select: none;
		/*box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);*/

		/*background-color: rgba(255, 255, 255, 0.1);*/
		/*background-color: #35989a;*/
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;

		color: white;
		/*font-size: 0.9em;*/
		line-height: 1em;
		text-align: left;
		justify-content: flex-end;

		transition: all .06s ease;
	}

	.card-body {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.empty .card-body {
		border-color: rgba(0, 0, 0, 0.3);
	}


	.shake {
		animation: Shake .6s ease-out;
	}

	@keyframes Shake {
		0%	{ transform: translate(calc(1.5*10.0px)); }
		10%	{ transform: translate(calc(1.5*-8.1px)); }
		20%	{ transform: translate(calc(1.5*6.4px)); }
		30%	{ transform: translate(calc(1.5*-4.9px)); }
		40%	{ transform: translate(calc(1.5*3.6px)); }
		50%	{ transform: translate(calc(1.5*-2.5px)); }
		60%	{ transform: translate(calc(1.5*1.6px)); }
		70%	{ transform: translate(calc(1.5*-0.9px)); }
		80%	{ transform: translate(calc(1.5*0.4px)); }
		90%	{ transform: translate(calc(1.5*-0.1px)); }
		100%	{ transform: translate(calc(1.5*0.0px)); }
	}
</style>
